var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { removeParentsTagIds, tagAxesMap, tagAxisIds } from '@cpsy-rmap-project/tags';
import _ from 'lodash';
export var removeTagsFromString = function (str) {
    return str
        .replace(/<\/?[^>]+(>|$)/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
};
// 文字列からTagにマッチするものを抽出する
var searchTagIdsFromString = function (str, tagAxisId) {
    return _.compact(_.values(tagAxesMap[tagAxisId]).map(function (tag) {
        return tag &&
            !tag.children &&
            str.toLowerCase().indexOf(tag.name.toLowerCase()) !== -1 &&
            tag.id;
    }));
};
export var getTagIdsFromString = function (str) {
    var matchTags = tagAxisIds.map(function (tagAxisId) {
        var _a;
        return (_a = {},
            _a[tagAxisId] = removeParentsTagIds(searchTagIdsFromString(str, tagAxisId)),
            _a);
    });
    return _.assign.apply(_, __spreadArray([{}], matchTags, false));
};
